(function () {
  const stopVideo = (section) => {
    const videos = section.querySelectorAll("video");

    if (videos) {
      videos.forEach((video) => {
        video.pause();
      });
    }
  };

  const playVideo = (section, width) => {
    const videos = section.querySelectorAll("video");
    const cards = section.querySelectorAll(".gallery-with-text__card");

    if (videos && cards) {
      cards.forEach((card) => {
        if (card.querySelector("video")) {
          if (card.classList.contains("active") || width < 990)
            card.querySelector("video").play();
          else card.querySelector("video").pause();
        }
      });
    }
  };

  const galleryTextSlide = () => {
    $(".gallery-with-text__card").hover(function () {
      let $this = $(this);
      $this.addClass("active");
      $this.siblings(".gallery-with-text__card").removeClass("active");
      setTimeout(function () {
        $this
          .children(".gallery-with-text__info")
          .children(".link--overlay")
          .addClass("active");
        $this
          .siblings(".gallery-with-text__card")
          .children(".gallery-with-text__info")
          .children(".link--overlay")
          .removeClass("active");
      }, 100);

      playVideo(
        $this.closest(".gallery-with-text-section")[0],
        document.documentElement.clientWidth
      );
    });
  };

  const initSection = () => {
    const sections = document.querySelectorAll(".gallery-with-text-section");

    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting)
          playVideo(entry.target, entry.boundingClientRect.width);
        else stopVideo(entry.target);
      });
    });

    const sectionResizeObserver = new ResizeObserver((entries) => {
      const [entry] = entries;
      let widthSlide = "100%";
      if (document.documentElement.clientWidth >= 990) {
        entry.target
          .querySelectorAll(".gallery-with-text__card")
          .forEach((card) => {
            if (card.classList.contains("active")) {
              widthSlide = card.getBoundingClientRect().width;
            }
          });
        entry.target.style.setProperty("--width-slide", `${widthSlide}px`);
      } else {
        entry.target.style.setProperty("--width-slide", "100%");
      }
      playVideo(entry.target, entry.contentRect.width);
    });

    sections.forEach((section) => {
      sectionObserver.observe(section);
      sectionResizeObserver.observe(section);
    });

    galleryTextSlide();
  };

  document.addEventListener("shopify:section:load", function () {
    initSection();
  });

  initSection();
})();

/* ---- Phones: auto-sliding carousel (see section setting "Auto-sliding carousel on phones").
   Desktop/tablet keep the hover layout above; this only runs under 750px. ---- */
(function () {
  const PHONE = window.matchMedia('(max-width: 749px)');
  /* tablet portrait also slides (one card per view, arrows), without auto-advance */
  const SLIDER = window.matchMedia('(max-width: 989px)');
  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  const setup = (section) => {
    if (section.dataset.mobileSliderReady === 'true') return;
    const root = section.querySelector('.gallery-with-text--mobile-slider');
    if (!root || root.dataset.mobileSlider !== 'true') return;
    section.dataset.mobileSliderReady = 'true';

    const track = root.querySelector('.gallery-with-text__wrapper');
    const cards = Array.from(root.querySelectorAll('.gallery-with-text__card'));
    const dotsWrap = root.querySelector('.gallery-with-text__dots');
    if (!track || cards.length < 2) return;
    const every = Math.max(2000, Number(root.dataset.mobileInterval || 5) * 1000);

    const dots = cards.map((_, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-label', (i + 1) + ' / ' + cards.length);
      b.addEventListener('click', () => { pause(); goTo(i); });
      dotsWrap && dotsWrap.appendChild(b);
      return b;
    });

    const step = () => cards[0].offsetWidth + (parseFloat(getComputedStyle(track).columnGap) || 0);
    const current = () => Math.round(track.scrollLeft / step());
    const goTo = (i) => track.scrollTo({ left: ((i % cards.length) + cards.length) % cards.length * step(), behavior: 'smooth' });
    const sync = () => {
      const cur = Math.min(current(), cards.length - 1);
      dots.forEach((d, i) => d.setAttribute('aria-current', i === cur ? 'true' : 'false'));
    };

    let timer = null;
    let visible = false;
    let held = false; // finger on the slider
    const start = () => {
      if (timer || !PHONE.matches || REDUCED.matches || !visible || held) return;
      timer = setInterval(() => goTo(current() + 1), every);
    };
    const pause = () => { clearInterval(timer); timer = null; };

    root.querySelector('[data-gallery-prev]')?.addEventListener('click', () => { pause(); goTo(current() - 1); });
    root.querySelector('[data-gallery-next]')?.addEventListener('click', () => { pause(); goTo(current() + 1); });

    let raf = null;
    track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
    track.addEventListener('touchstart', () => { held = true; pause(); }, { passive: true });
    track.addEventListener('touchend', () => { held = false; setTimeout(start, every); }, { passive: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        visible = entries.some((e) => e.isIntersecting);
        visible ? start() : pause();
      }, { threshold: 0.3 }).observe(root);
    } else {
      visible = true;
      start();
    }
    PHONE.addEventListener('change', () => { pause(); if (PHONE.matches) { sync(); start(); } });
    SLIDER.addEventListener('change', () => { if (SLIDER.matches) sync(); else track.scrollTo({ left: 0 }); });
    sync();
  };

  const init = () => document.querySelectorAll('.gallery-with-text-section').forEach(setup);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  document.addEventListener('shopify:section:load', (e) => {
    const target = e.target && e.target.classList && e.target.classList.contains('gallery-with-text-section') ? e.target : e.target && e.target.querySelector && e.target.querySelector('.gallery-with-text-section');
    if (target) setup(target);
  });
})();
